import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashSet(_this__u8e3s4) {
}
var HashSetClass;
function HashSet() {
  if (HashSetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static new_kotlin_collections_HashSet_1vjklh_k$(map) {
        var $this = this.new_kotlin_collections_AbstractMutableSet_hvoaax_k$();
        init_kotlin_collections_HashSet($this);
        $this.internalMap_1 = map;
        return $this;
      }
      static new_kotlin_collections_HashSet_ovxcsm_k$() {
        return this.new_kotlin_collections_HashSet_1vjklh_k$(InternalHashMap().new_kotlin_collections_InternalHashMap_iefrky_k$());
      }
      static new_kotlin_collections_HashSet_7p4ico_k$(elements) {
        var $this = this.new_kotlin_collections_HashSet_1vjklh_k$(InternalHashMap().new_kotlin_collections_InternalHashMap_jnbws6_k$(elements.get_size_woubt6_k$()));
        var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          $this.internalMap_1.put_4fpzoq_k$(element, true);
        }
        return $this;
      }
      static new_kotlin_collections_HashSet_uopk62_k$(initialCapacity, loadFactor) {
        return this.new_kotlin_collections_HashSet_1vjklh_k$(InternalHashMap().new_kotlin_collections_InternalHashMap_uj162q_k$(initialCapacity, loadFactor));
      }
      static new_kotlin_collections_HashSet_9nbh5e_k$(initialCapacity) {
        return this.new_kotlin_collections_HashSet_uopk62_k$(initialCapacity, 1.0);
      }
      add_utx5q5_k$(element) {
        return this.internalMap_1.put_4fpzoq_k$(element, true) == null;
      }
      clear_j9egeb_k$() {
        this.internalMap_1.clear_j9egeb_k$();
      }
      contains_aljjnj_k$(element) {
        return this.internalMap_1.contains_vbgn2f_k$(element);
      }
      isEmpty_y1axqb_k$() {
        return this.internalMap_1.get_size_woubt6_k$() === 0;
      }
      iterator_jk1svi_k$() {
        return this.internalMap_1.keysIterator_mjslfm_k$();
      }
      get_size_woubt6_k$() {
        return this.internalMap_1.get_size_woubt6_k$();
      }
    }
    initMetadataForClass($, 'HashSet', $.new_kotlin_collections_HashSet_ovxcsm_k$, VOID, [KtMutableSet()]);
    HashSetClass = $;
  }
  return HashSetClass;
}
//region block: exports
export {
  HashSet as HashSet2dzve9y63nf0v,
};
//endregion

//# sourceMappingURL=HashSet.mjs.map
